import { render, staticRenderFns } from "./CategoryNavPanel.vue?vue&type=template&id=99df5a48&scoped=true&"
import script from "./CategoryNavPanel.vue?vue&type=script&lang=js&"
export * from "./CategoryNavPanel.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNavPanel.vue?vue&type=style&index=0&id=99df5a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99df5a48",
  null
  
)

export default component.exports